import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { MCPConnectionDialog } from './mcp-connection-dialog';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common/config/constants';
import { cn } from '@/lib/utils';
import { Tooltip } from '@mui/material';

interface AIAssistantMenuItemProps {
    isMinimized?: boolean;
}

export const AIAssistantMenuItem: React.FC<AIAssistantMenuItemProps> = ({ isMinimized = false }) => {
    const { t } = useTranslation(namespace);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleClick = () => {
        setIsDialogOpen(true);
    };

    const translatedTitle = t('navigation.aiAssistant');

    const buttonContent = (
        <button
            onClick={handleClick}
            className={cn(
                "group relative flex items-center rounded-lg",
                "text-sm font-medium no-underline cursor-pointer border-none bg-transparent w-full text-left",
                "transition-all duration-300 ease-in-out",
                "px-4 py-3 mx-2 gap-3",
                "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800/50 hover:text-blue-600 dark:hover:text-blue-400"
            )}
            data-analytics-action="open_ai_assistant"
        >
            <div className={cn(
                "flex items-center justify-center flex-shrink-0 transition-colors duration-200",
                "text-slate-500 dark:text-slate-400 group-hover:text-blue-600 dark:group-hover:text-blue-400"
            )}>
                <Sparkles className="w-5 h-5" />
            </div>
            <span
                className="whitespace-nowrap overflow-hidden"
                style={{
                    maxWidth: isMinimized ? 0 : 200,
                    opacity: isMinimized ? 0 : 1,
                    transition: 'max-width 0.3s ease, opacity 0.2s ease',
                }}
            >
                {translatedTitle}
            </span>
        </button>
    );

    return (
        <>
            <Tooltip title={isMinimized ? translatedTitle : ''} placement="right" arrow disableHoverListener={!isMinimized}>
                {buttonContent}
            </Tooltip>

            <MCPConnectionDialog
                open={isDialogOpen}
                onOpenChange={setIsDialogOpen}
            />
        </>
    );
};

export default AIAssistantMenuItem;
